/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React from "react";
import PropTypes from "prop-types";
import BackgroundPanel from "./BackgroundPanel";

function OverlayPanel({
    width,
    height,
    onClickHandler,
    color = "#000",
    aframeClasses,
    ...otherAttributes
}) {
    return (
        <BackgroundPanel
            class={aframeClasses}
            onClick={onClickHandler}
            opacity={0.7}
            width={width}
            height={height}
            backgroundColor={color}
            {...otherAttributes}
        />
    );
}

OverlayPanel.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default OverlayPanel;
